import { createSelector } from 'reselect';

// Config
import { getStripeCheckoutFlowEnabledSelector } from './AddNewCard.state';
import {
  priorityOrder as defaultPriorityOrder,
  getPayNowPriorityOrder,
} from '@redux/actions/payment/selectedPaymentTypeActions';
import { getIsApplicationSelector } from '@redux/reducers/app/appSelector';
import {
  getConfirmedDeliveryAddressSelector,
  getSelectedDeliveryChoiceIdSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { getSavedCardFormSubmitFailedSelector } from '@redux/reducers/form/formSelector';
import {
  getIsCardFormValidSelector,
  getSelectedPaymentTypeSelector,
  getSelectedSavedCardSelector,
} from '@redux/reducers/payment/paymentSelector';
import {
  getCustomerPreferencesPaymentChoiceSelector,
  getSavedPaymentCardsSelector,
  getSelectedBillingAddressAddressSelector,
} from '@redux/reducers/user/userSelector';

const payNowCategoryState = createSelector(
  [
    getConfirmedDeliveryAddressSelector,
    getSelectedDeliveryChoiceIdSelector,
    getIsCardFormValidSelector,
    getSelectedPaymentTypeSelector,
    getSelectedSavedCardSelector,
    getSavedPaymentCardsSelector,
    getSelectedBillingAddressAddressSelector,
    getSavedCardFormSubmitFailedSelector,
    getIsApplicationSelector,
    getCustomerPreferencesPaymentChoiceSelector,
    getStripeCheckoutFlowEnabledSelector,
  ],
  (
    confirmedDeliveryAddress,
    selectedDeliveryChoiceId,
    isCardFormValid,
    selectedPaymentType,
    selectedSavedCard,
    savedPaymentCards,
    selectedBillingAddress,
    savedCardFormSubmitFailed,
    isApplication,
    paymentChoice,
    stripeCheckoutFlowEnabled,
  ) => ({
    confirmedDeliveryAddress: confirmedDeliveryAddress?.address,
    isCardFormValid,
    priorityOrder: getPayNowPriorityOrder(paymentChoice) ?? defaultPriorityOrder,
    requestBillingAddressFromApplePay: !isApplication,
    savedCardFormSubmitFailed,
    savedPaymentCards,
    selectedBillingAddress,
    selectedDeliveryChoiceId,
    selectedPaymentType,
    selectedSavedCard,
    stripeCheckoutFlowEnabled,
  }),
);

export default payNowCategoryState;
